import {
  ADD_DYNAMIC_ELEMENT,
  DELETE_DYNAMIC_ELEMENT,
  EDIT_DYNAMIC_ELEMENT,
  ON_UPDATE,
  SET_ALL_DYNAMIC_ELEMENTS,
  SET_ALL_DYNAMIC_ELEMENTS_TO_INITIAL_STATE,
  SET_ELEMENT_TO_DELETE,
  SET_IS_FROM_PROJECT,
  SET_IS_HOW_TO_ADD_MODAL_OPEN,
  SET_LOADING,
  SET_OPEN_CONFIRM_DELETE_MODAL,
  SET_PARTS_RELATED_TO_ELEMENT_TO_DELETE,
} from "context/types"

export const initialState = {
  dynamicElements: [],
  isFromProject: false,
  updating: false,
  loading: false,
  deleteElement: {
    openConfirmModal: false,
    elementToDelete: null,
    partsRelated: null,
  },
  isHowToAddModalOpen: false,
}

const DynamicElementsReducer = (state, action) => {
  switch (action.type) {
    case ON_UPDATE: {
      return {
        ...state,
        updating: true,
      }
    }

    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload !== undefined ? action.payload : true,
      }
    }

    case SET_IS_FROM_PROJECT: {
      return {
        ...state,
        isFromProject: action.payload,
      }
    }

    case SET_ALL_DYNAMIC_ELEMENTS: {
      return {
        ...state,
        dynamicElements: action.payload.data,
        loading: false,
      }
    }

    case SET_ALL_DYNAMIC_ELEMENTS_TO_INITIAL_STATE: {
      // state.addDynamicElementsToInitialState()
      // const newState = new DynamicElementManager(
      //   [],
      //   state.isFromProject,
      //   state.updating,
      //   state.loading,
      //   state.dispatches,
      //   state.deleteElement,
      //   state.isHowToAddModalOpen,
      // )
      // return newState
      return initialState
    }

    case ADD_DYNAMIC_ELEMENT: {
      return {
        ...state,
        dynamicElements: [...state.dynamicElements, action.payload.element],
        loading: false,
      }
    }

    case EDIT_DYNAMIC_ELEMENT: {
      state.editElement(action.payload.element)
      return {
        ...state,
        loading: false,
      }
    }

    case DELETE_DYNAMIC_ELEMENT: {
      const newData = state.deleteDynamicElement(action.payload.element)
      return {
        ...state,
        dynamicElements: newData,
        loading: false,
      }
    }

    case SET_OPEN_CONFIRM_DELETE_MODAL: {
      return {
        ...state,
        deleteElement: {
          ...state.deleteElement,
          openConfirmModal: action.payload,
        },
      }
    }

    case SET_ELEMENT_TO_DELETE: {
      return {
        ...state,
        deleteElement: {
          ...state.deleteElement,
          elementToDelete: action.payload,
        },
      }
    }

    case SET_IS_HOW_TO_ADD_MODAL_OPEN: {
      return {
        ...state,
        isHowToAddModalOpen: action.payload,
      }
    }

    case SET_PARTS_RELATED_TO_ELEMENT_TO_DELETE: {
      return {
        ...state,
        deleteElement: {
          ...state.deleteElement,
          partsRelated: action.payload,
        },
      }
    }

    default: {
      return state
    }
  }
}

export default DynamicElementsReducer
